import React, { useState }  from "react";
import { Modal, Button } from 'react-bootstrap';
import {faMinus} from '@fortawesome/free-solid-svg-icons';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Faqcontainer: React.FC = () => {
    const [faq1, setFaq1] = useState<boolean>(false);
    const [faq2, setFaq2] = useState<boolean>(false);
    const [faq3, setFaq3] = useState<boolean>(false);
    const [faq4, setFaq4] = useState<boolean>(false);
    const [faq5, setFaq5] = useState<boolean>(false);
    const [faq6, setFaq6] = useState<boolean>(false);
    const [faq7, setFaq7] = useState<boolean>(false);
    const [faq8, setFaq8] = useState<boolean>(false);
    const [faq9, setFaq9] = useState<boolean>(false);
    const [faq10, setFaq10] = useState<boolean>(false);
    const [faq11, setFaq11] = useState<boolean>(false);
    const [faq12, setFaq12] = useState<boolean>(false);
    const [faq13, setFaq13] = useState<boolean>(false);
    const [faq14, setFaq14] = useState<boolean>(false);
    const [faq15, setFaq15] = useState<boolean>(false);
    const [faq16, setFaq16] = useState<boolean>(false);
    
    const [isShow, invokeModal] = React.useState(false)
    const initModal = () => {
        return invokeModal(true)
    }

    const close = () => {
        return invokeModal(false)
    }
    

    const showfaq1 = () => {
        if (faq1 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(true);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }
        
    }
    
    const showfaq2 = () => {
        if (faq2 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(false);
            setFaq2(true);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }
    }
    
    const showfaq3 = () => {
        if (faq3 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(false);
            setFaq2(false);
            setFaq3(true);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }
    }
    
    
    const showfaq4 = () => {
        if (faq4 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(true);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }
    }
    
    const showfaq5 = () => {
        if (faq5 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(true);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }
    }
    
    const showfaq6 = () => {
        if (faq6 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(true);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }
    }
    
    const showfaq7 = () => {
        if (faq7 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(true);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }
    }
    
    const showfaq8 = () => {
        if (faq8 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(true);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }
    }
    
    const showfaq9 = () => {
        if (faq9 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(true);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }
    }
    
    const showfaq10 = () => {
        if (faq10 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(true);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }
    }
    
    
    const showfaq11 = () => {
        if (faq11 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(true);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }
    }
    
    
    const showfaq12 = () => {
        if (faq12 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(true);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }
    }
    
    const showfaq13 = () => {
        if (faq13 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(true);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }
    }
    
    const showfaq14 = () => {
        if (faq14 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(true);
            setFaq15(false);
            setFaq16(false);
            
        }
    }
    
    
    const showfaq15 = () => {
        if (faq15 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(true);
            setFaq16(false);
            
        }
    }
    
    
    const showfaq16 = () => {
        if (faq16 === true){
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(false);
            
        }else {
            setFaq1(false);
            setFaq2(false);
            setFaq3(false);
            setFaq4(false);
            setFaq5(false);
            setFaq6(false);
            setFaq7(false);
            setFaq8(false);
            setFaq9(false);
            setFaq10(false);
            setFaq11(false);
            setFaq12(false);
            setFaq13(false);
            setFaq14(false);
            setFaq15(false);
            setFaq16(true);
            
        }
    }

    return(
      <>
      <p  className="nav-links23"  onClick={initModal}>FAQs</p>

      <Modal show={isShow}>
                <Modal.Header closeButton onClick={close}>
                <Modal.Title className="text-center" style={{color: "#509b35"}}>Read Our FAQ'S</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row" >
                        
                        <div className="col-md-12">
                        <div>
                            <h3 className="Fatag">FAQ'S</h3>
                        </div>
                        <br/>
                        <div className="row">
                            
                            <div className="col-md-12">
                                <div className="faqfill" onClick={showfaq1}>
                                    <div>
                                        What is the program all about?
                                        <div style={{float: "right"}}>
                                        {faq1 ? (<>
                                            <FontAwesomeIcon icon={faMinus} /> 
                                        </>): (<>
                                            <FontAwesomeIcon icon={faPlus} /> 
                                        </>)}
                                        
                                        </div>
                                    </div>
                                    
                                    
                                </div>
                                {faq1 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>The program at Doyenify Academy is designed to provide comprehensive and 
                                                    specialized training in various fields. We offer a range of courses that 
                                                    cover topics such as technology, business, marketing, creative arts, and more. 
                                                    Our programs are carefully crafted to equip participants
                                                    with the skills, knowledge, and practical experience necessary to excel in their chosen industry.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}
                                
                                <hr style={{margin: "0", padding: "0"}}/>
                                <div className="faqfill"  onClick={showfaq2}>
                                    How are the courses structured?
                                    <div style={{float: "right"}}>
                                        {faq2 ? (<>
                                                <FontAwesomeIcon icon={faMinus} /> 
                                            </>): (<>
                                                <FontAwesomeIcon icon={faPlus} /> 
                                            </>)} 
                                    </div>
                                </div>
                                {faq2 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>The courses at Doyenify Academy are structured to provide a balanced blend of theoretical 
                                                and practical applications. Participants will have access to engaging learning materials, 
                                                interactive assignments, real-world case studies, and expert guidance from experienced instructors.
                                                The curriculum is designed to ensure a holistic learning experience and foster a deep understanding of the subject matter.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}
                                <hr  style={{margin: "0", padding: "0"}}/>

                                <div  className="faqfill"  onClick={showfaq3}>
                                    What is the duration of the programme?
                                    <div style={{float: "right"}}>
                                        {faq3 ? (<>
                                                <FontAwesomeIcon icon={faMinus} /> 
                                            </>): (<>
                                                <FontAwesomeIcon icon={faPlus} /> 
                                            </>)} 
                                    </div>
                                </div>

                                {faq3 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>The programme is 12 weeks long, consisting of intensive training.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}

                                <hr  style={{margin: "0", padding: "0"}}/>

                                <div  className="faqfill" onClick={showfaq4}>
                                    What can I expect to learn from the program?
                                    <div style={{float: "right"}}>
                                        {faq4 ? (<>
                                                <FontAwesomeIcon icon={faMinus} /> 
                                            </>): (<>
                                                <FontAwesomeIcon icon={faPlus} /> 
                                            </>)} 
                                    </div>
                                </div>

                                {faq4 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>The program aims to provide participants with a solid
                                                foundation in their chosen field of study. You can expect to gain in-depth knowledge of 
                                                industry-specific concepts, acquire practical skills through hands-on projects, develop 
                                                critical thinking and problem-solving abilities, and learn how to effectively apply your 
                                                knowledge in real-world scenarios. Additionally, our programs often emphasize industry trends,
                                                best practices, and emerging technologies to ensure you stay relevant in a rapidly evolving 
                                                professional landscape.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}

                                <hr  style={{margin: "0", padding: "0"}}/>

                                <div  className="faqfill" onClick={showfaq5}>
                                    Will there be a certificate after the programme?
                                    <div style={{float: "right"}}>
                                        {faq5 ? (<>
                                                <FontAwesomeIcon icon={faMinus} /> 
                                            </>): (<>
                                                <FontAwesomeIcon icon={faPlus} /> 
                                            </>)} 
                                    </div>
                                </div>

                                {faq5 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>Yes, upon successful completion of the programme, 
                                                participants will receive a certificate from Doyenify Academy.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}

                                <hr  style={{margin: "0", padding: "0"}}/>

                                <div  className="faqfill" onClick={showfaq6}>
                                    What are the requirements for the program?
                                    <div style={{float: "right"}}>
                                        {faq6 ? (<>
                                                <FontAwesomeIcon icon={faMinus} /> 
                                            </>): (<>
                                                <FontAwesomeIcon icon={faPlus} /> 
                                            </>)}  
                                    </div>
                                </div>

                                {faq6 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>The requirements for the program may vary depending on the specific course.
                                                Generally, participants should have a basic understanding of the subject matter and possess the necessary
                                                equipment (such as a computer with internet access) to participate in online learning activities. Detailed 
                                                requirements can be found on the course page.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}

                                <hr  style={{margin: "0", padding: "0"}}/>

                                <div  className="faqfill" onClick={showfaq7}>
                                    How is the lecture delivered?
                                    <div style={{float: "right"}}>
                                        {faq7 ? (<>
                                                <FontAwesomeIcon icon={faMinus} /> 
                                            </>): (<>
                                                <FontAwesomeIcon icon={faPlus} /> 
                                            </>)}
                                    </div>
                                </div>

                                {faq7 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>The lectures are delivered virtually, allowing participants to 
                                                access the course material and engage with instructors remotely.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}

                                <hr  style={{margin: "0", padding: "0"}}/>

                                <div  className="faqfill" onClick={showfaq8}>
                                    Can a student or working class apply?
                                    <div style={{float: "right"}}>
                                        {faq8 ? (<>
                                                <FontAwesomeIcon icon={faMinus} /> 
                                            </>): (<>
                                                <FontAwesomeIcon icon={faPlus} /> 
                                            </>)} 
                                    </div>
                                </div>

                                {faq8 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>Absolutely! Doyenify Academy welcomes both students and working professionals to apply for our programs. 
                                                We believe in providing learning opportunities to individuals from diverse backgrounds.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}

                                <hr  style={{margin: "0", padding: "0"}}/>

                                <div  className="faqfill" onClick={showfaq9}>
                                    What are my chances of getting a job after the program?
                                    <div style={{float: "right"}}>
                                        {faq9 ? (<>
                                                <FontAwesomeIcon icon={faMinus} /> 
                                            </>): (<>
                                                <FontAwesomeIcon icon={faPlus} /> 
                                            </>)} 
                                    </div>
                                </div>

                                {faq9 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>While Doyenify Academy aims to equip participants with the necessary skills
                                                and knowledge to enhance their career prospects, job placement cannot be guaranteed. 
                                                However, the academy focuses on providing valuable industry insights and practical 
                                                training to increase the chances of participants securing job opportunities in their 
                                                respective fields.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}

                                <hr  style={{margin: "0", padding: "0"}}/>

                                <div  className="faqfill" onClick={showfaq10}>
                                    Will I have access to industry experts?
                                    <div style={{float: "right"}}>
                                        {faq10 ? (<>
                                                <FontAwesomeIcon icon={faMinus} /> 
                                            </>): (<>
                                                <FontAwesomeIcon icon={faPlus} /> 
                                            </>)} 
                                    </div>
                                </div>

                                {faq10 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>Yes, at Doyenify Academy, we believe in learning from the best. 
                                                Our programs feature industry experts who bring a wealth of knowledge and practical 
                                                experience to the table. You will have the opportunity to interact with these experts 
                                                through virtual lectures, live Q&A sessions, and mentorship programs. Their insights and 
                                                guidance will provide valuable perspectives and help you gain a deeper understanding of your chosen field.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}

                                <hr  style={{margin: "0", padding: "0"}}/>

                                <div  className="faqfill" onClick={showfaq11}>
                                    Can I start at any time?
                                    <div style={{float: "right"}}>
                                        {faq11 ? (<>
                                                <FontAwesomeIcon icon={faMinus} /> 
                                            </>): (<>
                                                <FontAwesomeIcon icon={faPlus} /> 
                                            </>)} 
                                    </div>
                                </div>

                                {faq11 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>No, you can only start a class when it commences or at most a week after the commencement date. 
                                                We operate on a cohort-based system to ensure an optimal learning experience for all participants.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}

                                <hr  style={{margin: "0", padding: "0"}}/>

                                <div  className="faqfill" onClick={showfaq12}>
                                    In what currency can I make payment?
                                    <div style={{float: "right"}}>
                                        {faq12 ? (<>
                                                <FontAwesomeIcon icon={faMinus} /> 
                                            </>): (<>
                                                <FontAwesomeIcon icon={faPlus} /> 
                                            </>)} 
                                    </div>
                                </div>

                                {faq12 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>You can make payment in the currency of your country. 
                                                We accept payments in local currencies to accommodate students from different regions.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}

                                <hr  style={{margin: "0", padding: "0"}}/>

                                <div  className="faqfill" onClick={showfaq13}>
                                    When can I register?
                                    <div style={{float: "right"}}>
                                        {faq13 ? (<>
                                                <FontAwesomeIcon icon={faMinus} /> 
                                            </>): (<>
                                                <FontAwesomeIcon icon={faPlus} /> 
                                            </>)} 
                                    </div>
                                </div>

                                {faq13 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>You can register at any time for the courses available on our platform. However, 
                                                if a class you're interested in has already commenced, 
                                                you will need to join the next available cohort to begin your learning journey.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}

                                <hr  style={{margin: "0", padding: "0"}}/>

                                <div  className="faqfill" onClick={showfaq14}>
                                    What is a cohort-based system?
                                    <div style={{float: "right"}}>
                                    {faq14 ? (<>
                                                <FontAwesomeIcon icon={faMinus} /> 
                                            </>): (<>
                                                <FontAwesomeIcon icon={faPlus} /> 
                                            </>)} 
                                    </div>
                                </div>

                                {faq14 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>A cohort-based system at Doyenify Academy means
                                                that courses have specific start dates, and all enrolled students progress through the program together as a group.
                                                This allows for a collaborative learning environment and fosters a sense of community among participants.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}

                                <hr  style={{margin: "0", padding: "0"}}/>

                                <div  className="faqfill" onClick={showfaq15}>
                                    Can I access course materials after the course ends?
                                    <div style={{float: "right"}}>
                                        {faq15 ? (<>
                                                <FontAwesomeIcon icon={faMinus} /> 
                                            </>): (<>
                                                <FontAwesomeIcon icon={faPlus} /> 
                                            </>)}  
                                    </div>
                                </div>

                                {faq15 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>Yes, enrolled students will have access to the course materials 
                                                for a certain period even after the course ends. 
                                                This ensures you can review the content and continue learning at your own pace.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}

                                <hr  style={{margin: "0", padding: "0"}}/>

                                <div  className="faqfill" onClick={showfaq16}>
                                    Are there any prerequisites for the courses?
                                    <div style={{float: "right"}}>
                                        {faq16 ? (<>
                                                <FontAwesomeIcon icon={faMinus} /> 
                                            </>): (<>
                                                <FontAwesomeIcon icon={faPlus} /> 
                                            </>)}  
                                    </div>
                                </div>

                                {faq16 ? (
                                    <>
                                        <div className="row">
                                            <div className="col-md-1">

                                            </div>
                                            <div className="col-md-10">
                                                <p style={{textAlign: "justify"}}>The prerequisites for each course may vary. 
                                                Some courses may require prior knowledge or experience in the subject, 
                                                while others may be suitable for beginners. 
                                                Check the course details on our website for specific prerequisites.</p>
                                            </div>
                                            <div className="col-md-1">

                                            </div>
                                        </div>
                                    </>
                                ):(<>
                                
                                </>)}


                                <div>
                                <br/>
                                <br/>
                                **NOTE**: If you can't find the information you're looking for, feel free to reach out to our support team.
                                </div>
                                
                            </div>
                            
                        
                            
                        </div>
                        
                        </div>
                        
                        

                    </div>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="danger" onClick={close}>
                    Close
                </Button>
                
                </Modal.Footer>
            </Modal>
    </>
    
    )
}

export default Faqcontainer;